import { useState, useEffect } from "react";

export function BetWindow({ element, isSelected, onClicked, oddsFormat }) {
  const [displayText, setDisplayText] = useState(element.value);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  // Extract numerator and denominator for fraction display
  const renderFraction = (fractionStr) => {
    // Ensure fractionStr is a string and handle cases when it's not
    const fraction = String(fractionStr);

    const isFraction = fraction && fraction.includes("/") && fraction !== "X";

    if (!isFraction) {
      // Centered "X" placeholder when fraction is invalid or missing
      return (
        <span
          style={{
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            height: "40px", // ensure height matches regular odds layout
            minWidth: "24px",
            fontSize: "0.9em",
            fontWeight: "500",
            userSelect: "none",
          }}
        >
          X
        </span>
      );
    }

    const [numerator, denominator] = fraction.split("/");

    return (
      <span
        style={{
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center",
          fontSize: "0.9em",
          lineHeight: 1,
          height: "40px",
          minWidth: "24px",
          justifyContent: "center",
          userSelect: "none",
        }}
      >
        <span
          style={{
            borderBottom: "1px solid black", // thinner line
            padding: "0 4px", // slightly longer horizontal line
            // marginBottom: "2px",
          }}
        >
          {numerator}
        </span>
        <span>{denominator}</span>
      </span>
    );
  };

  const getAbbreviatedText = (text) => {
    if (text.includes("/")) {
      const parts = text.split("/");
      return parts.map((part) => part.charAt(0).toUpperCase()).join("/");
    } else if (/\d/.test(text)) {
      const number = text.match(/[\d.]+/);
      return number ? number[0] : text;
    } else {
      return text.charAt(0).toUpperCase();
    }
  };

  const updateDisplayText = () => {
    const currentIsMobile = window.innerWidth <= 767;
    setIsMobile(currentIsMobile);

    if (currentIsMobile) {
      setDisplayText(getAbbreviatedText(element.value));
    } else {
      setDisplayText(element.value);
    }
  };

  useEffect(() => {
    updateDisplayText();

    const handleResize = () => {
      updateDisplayText();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [element.value]);

  if (!element.odd) {
    return (
      <div className="bet-window" onClick={() => onClicked(element)}>
        <div className="bet-option">
          {displayText.split(" ")[1] === "undefined" ? "X" : displayText}
        </div>
        <div className="bet-coef">X</div>
      </div>
    );
  }

  return (
    <div className="bet-window" onClick={() => onClicked(element)}>
      <div className={`${isSelected ? "active" : ""} bet-option`}>
        {displayText}
      </div>
      <div className="bet-coef">
        {oddsFormat === "fractional" && isMobile
          ? renderFraction(element.odd)
          : element.odd}
      </div>
    </div>
  );
}
